//Products
export const PRODUCTS_LIST = 'products';
export const PRODUCTS_STORE = 'products';

//Categories
export const CATEGORY_LIST = 'categories';

//Taxes
export const TAX_LIST = 'taxes';

//Client
export const CLIENT_LIST = 'clients';

// Invoice
export const INVOICES = 'invoices';
export const TAX_INVOICES = 'tax-invoices';
export const INCOME_INVOICES = 'income-invoices';
export const INVOICES_LIST = 'invoices/list/view';
export const INVOICES_SEND = 'invoice-send';
export const STOP_RECURRING_INVOICES = 'stop-recurring';

//Estimate
export const ESTIMATE = 'estimates';
export const ESTIMATE_LIST = 'estimates/list/view';
export const ESTIMATE_SEND = 'estimates-send';
export const ESTIMATE_NUMBER = 'get-estimate-number';

//Quotation
export const QUOTATION = 'quotations';
export const QUOTATION_LIST = 'quotations/list/view';
export const QUOTATION_SEND = 'quotations-send';
export const QUOTATION_NUMBER = 'get-quotation-number';

//Payment History
export const PAYMENTHISTORY = 'payment-histories';

//Expense
export const EXPENSE_LIST = 'expenses';
//Expense
export const PURPOSE_LIST = 'purposes';

//Shipments
export const SHIPMENT_LIST = 'shipments/load';
export const TRANSPORTATION_LIST = 'transportations/load';
